const AboutPage = () => (
  <div className="bg-gray-950 text-white min-h-screen">
    <header className="w-full py-4 px-6 bg-gray-900/50 backdrop-blur-md border-b border-gray-800/50 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">
            Imposter Game
          </span>
        </div>
        <nav className="flex items-center gap-4 text-sm">
          <a href="/index.html" className="text-gray-400 hover:text-white transition-colors">Home</a>
          <a href="/about.html" className="text-indigo-300 font-semibold">About</a>
        </nav>
      </div>
    </header>

    <main className="max-w-6xl mx-auto px-6 py-12 space-y-10">
      <section className="space-y-4">
        <p className="text-sm uppercase tracking-[0.2em] text-indigo-300">About</p>
        <h1 className="text-4xl font-bold leading-tight">How Imposter Game is built</h1>
        <p className="text-gray-300 text-lg leading-relaxed">
          This project runs as a static, multi-page build so core content is immediately available for search engines and players.
          The main gameplay lives on the home page, while supporting pages like this one are rendered separately for clean URLs and SEO.
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-6">
        <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 space-y-3">
          <h2 className="text-xl font-semibold">Static-first delivery</h2>
          <p className="text-gray-400">
            HTML and CSS ship directly from the CDN, so crawlers see meaningful content without waiting for client-side rendering.
          </p>
        </div>
        <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 space-y-3">
          <h2 className="text-xl font-semibold">React where it matters</h2>
          <p className="text-gray-400">
            Interactive pieces hydrate on demand. Each page has its own entry point so bundles stay lean and scoped.
          </p>
        </div>
      </section>

      <section className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 space-y-4">
        <h2 className="text-xl font-semibold">What’s inside</h2>
        <ul className="list-disc list-inside text-gray-400 space-y-2">
          <li>Static HTML per page for SEO-friendly structure</li>
          <li>Shared Tailwind build for consistent styling</li>
          <li>Esbuild multi-entry bundling for fast builds</li>
          <li>Cloudflare Pages-ready output under <code>dist/</code></li>
        </ul>
      </section>
    </main>

    <footer className="w-full py-8 px-6 bg-gray-900/50 backdrop-blur-md border-t border-gray-800/50 mt-auto">
      <div className="max-w-6xl mx-auto text-gray-400 text-sm">
        Built for friends who love social deduction games. Play responsibly and have fun!
      </div>
    </footer>
  </div>
);

export default AboutPage;
